import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import './header.css';
import { links } from '../../json/headerLinks';

const Header = () => {
    const [overlay, setOverlay] = useState(false);
    const [activeSubmenu, setActiveSubmenu] = useState(null);

  const handleMouseEnter = (submenu) => {
    setActiveSubmenu(submenu);
  }
  const handleMouseLeave = () => {
    setActiveSubmenu(null);
  }

  const hideMenu = () => {
    const div =  document.getElementById('navbarNav');
    div.classList.remove('show');
    setOverlay(false);
  }
  
  return (
    <>
        {
            overlay ? <div onClick={()=>{setOverlay(!overlay)}} className='overlay-menu' data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav"></div> : null
        }
        <div id='header'>
            <nav className="navbar navbar-expand-lg navbar-light bg-gob">
                <div className="container-fluid">
                    <Link className="nav-link active" aria-current="page" to="/">
                        {
                            isMobile ? <img className='logo-menu' src='../assets/imgs/Pleca/Cecultah.png'/> : <span>CONSEJO ESTATAL PARA LA CULTURA Y LAS ARTES DE HIDALGO</span>
                        }
                    </Link>
                    <span className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" onClick={()=>{setOverlay(true)}} style={{color: "white"}} viewBox="0 0 32 32">
                        MENÚ
                    </span>
                    <div className="collapse navbar-collapse second-navbar-gob" id="navbarNav">
                        <ul id='menu-list' className="navbar-nav"
                            onClick={() => {setActiveSubmenu(null); hideMenu()}}>
                            <li className="nav-item">
                                <Link to="/" className="nav-link">Inicio</Link>
                            </li>
                           {
    links.map((item, index) => (
        <li key={index} className="nav-item dropdown"
            onMouseEnter={() => handleMouseEnter(item.nombre)}
            onMouseLeave={handleMouseLeave}>
            
            {/* Enlace para recursos estáticos */}
            {item.esExterno ? (
                <a
                    href={item.link}
                    className="nav-link"
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href = item.link;
                        setActiveSubmenu(null);
                    }}
                    target={item.target || "_self"}
                >
                    {item.nombre}
                </a>
            ) : (
                /* Enlace para rutas de React */
                <Link
                    to={item.link}
                    className="nav-link"
                    onClick={() => setActiveSubmenu(null)}
                >
                    {item.nombre}
                </Link>
            )}

            {/* Submenús (se mantiene igual) */}
            {item.submenu && item.submenu.length > 0 && (
                <ol className={`dropdown-menu ${activeSubmenu === item.nombre ? "show" : ""}`}>
                    {item.submenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                            <Link 
                                className="dropdown-item" 
                                to={subItem.subMenuUrl}
                                onClick={() => setActiveSubmenu(null)}
                            >
                                {subItem.subMenuNombre}
                            </Link>
                        </li>
                    ))}
                </ol>
            )}
            <span className={`triangle ${activeSubmenu === item.nombre ? "show" : ""}`} />
        </li>
    ))
}
                            <li className="nav-item nav-item-whatsapp">
                                <a
                                    href="https://script.google.com/macros/s/AKfycbwY9pre_VbhM686QHOhzktSeqGqAF8aOTuY2lEm2srdMyRsBGsEYLJBVz0XKTDsEyb6/exec?loc=web"
                                    className="nav-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setActiveSubmenu(null)}
                                >
                                    <svg
                                     className="whatsapp-icon"
                                     viewBox="0 0 32 32"
                                     xmlns="http://www.w3.org/2000/svg"
                                     aria-label="WhatsApp"
                                     >
                                        <path
                                            fill="currentColor"
                                            d="M16.001 2.667c-7.363 0-13.334 5.97-13.334 13.333 0 2.352.615 4.646 1.782 6.666L2.667 29.333l6.822-1.789a13.27 13.27 0 0 0 6.512 1.706h.006c7.362 0 13.333-5.97 13.333-13.333 0-3.562-1.388-6.912-3.907-9.431a13.24 13.24 0 0 0-9.432-3.819zm0 24.4h-.005a11.06 11.06 0 0 1-5.64-1.545l-.405-.24-4.048 1.062 1.08-3.947-.264-.405a11.05 11.05 0 0 1-1.693-5.892c0-6.114 4.976-11.09 11.093-11.09a11.03 11.03 0 0 1 7.845 3.253 11.03 11.03 0 0 1 3.248 7.847c-.003 6.115-4.978 11.09-11.111 11.09zm6.086-8.307c-.334-.167-1.97-.972-2.275-1.083-.305-.111-.527-.167-.749.167-.222.333-.86 1.083-1.054 1.305-.194.222-.389.25-.722.083-.334-.167-1.41-.52-2.686-1.658-.993-.885-1.664-1.98-1.858-2.313-.194-.334-.021-.514.146-.68.15-.15.334-.389.5-.583.167-.194.222-.333.334-.556.111-.222.056-.417-.028-.583-.083-.167-.749-1.805-1.026-2.472-.27-.65-.545-.561-.749-.572a13.9 13.9 0 0 0-.638-.011.98.98 0 0 0-.71.334c-.243.263-.93.91-.93 2.215s.953 2.566 1.086 2.743c.132.176 1.877 2.865 4.547 4.017.635.274 1.13.438 1.517.56.638.203 1.218.174 1.677.106.512-.076 1.577-.645 1.799-1.267.222-.622.222-1.155.156-1.267-.067-.111-.244-.178-.517-.312z"
                                        />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </>
  )
}

export default Header